// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Select[data-v-01850242]{border:var(--input-border);height:var(--input-height);padding:0 var(--input-padding-x);border-radius:var(--input-radius);background-color:var(--input-bg);width:100%}.Select[data-v-01850242]:focus{border-color:var(--input-focus-border-color);box-shadow:var(--input-focus-shadow)}.Select[data-v-01850242]:disabled{cursor:not-allowed;background-color:var(--input-disabled-bg)}.Select.is-invalid[data-v-01850242]{border-color:red}\n", ""]);
// Exports
module.exports = exports;
